
$(document).find(".accrodion-title").click(function () {
     if ($(this).hasClass("active")){
         // console.log(this + "if");
         $(this).removeClass("active");
         $(this).next(".accordion-content").removeClass("is-selected")
    } else{
         $(document).find(".accrodion-title").removeClass("active");
         $(document).find(".accordion-content").removeClass("is-selected");
         // console.log(this + "else");
          $(this).addClass("active");
         $(this).next(".accordion-content").addClass("is-selected") 
    }
   
  });

  // Faq accordion js

    $(document).find(".accordion-title").click(function () {
     if ($(this).hasClass("active")){
         // console.log(this + "if");
         $(this).removeClass("active");
         $(this).next(".accordion-content").removeClass("is-selected")
    } else{
         $(document).find(".accordion-title").removeClass("active");
         $(document).find(".accordion-content").removeClass("is-selected");
         // console.log(this + "else");
          $(this).addClass("active");
         $(this).next(".accordion-content").addClass("is-selected") 
    }
   
  });  
   
//       tab form js
      
      $(document).ready(function(){
     $("ul.tab_section li").click(function(){
        $("ul.tab_section li").removeClass("active")
        $(".tab-form, #contact_form").addClass("active")
        $(this).addClass("active")
    });
     $("#back").click(function(){
         $(".tab-form , #contact_form").removeClass("active")
     });
});
          $(document).ready(function(){
$('.try-now-btn a').click(function(){
    $(".ProductForm__AddToCart").click();
}); });
     // product slider
      //      $(document).ready(function(){
      //   $('.template-index .ProductList').slick({
      //   lazyLoad: 'ondemand',
      //   slidesToShow: 5,
      //   slidesToScroll: 1,
      //     dots: true,
      //      responsive: [
      //           {
      //             breakpoint: 767,
      //               settings: {
      //               slidesToShow: 1,
      //               slidesToScroll: 1,
      //               infinite: true,
      //               arrows:false,
      //               dots: true
      //             }
      //           }
      //         ]
      // });
      //        settings ={
      //           slidesToShow: 4,
      //         slidesToScroll: 1,
      //        };
      //        $window = $(window);
      //        $slick_slider = $('.template-index .ProductList');
      //        $window.on('resize', function() {
      //       if ($window.width() < 767) {
      //         if ($slick_slider.hasClass('slick-initialized'))
      //           $slick_slider.slick('unslick');
      //         return
      //       }
      //       if ( ! $slick_slider.hasClass('slick-initialized'))
      //         return $slick_slider.slick(settings);
      //     });  

      // });


$(document).ready(function(){
  productSlider(".template-index .featured_section .ProductList", true, 4, 1, false, true, false, 767, 1);
  productSlider(".template-index .featured_section_2 .ProductList", true, 4, 4, false, true, false, 767, 1);
  productSlider(".block_sliders", true, 5, 1, false, true, true, 767, 1);
  productSlider('.media_slider', false, 3, 1, false, true, true, 767, 1);
  productSlider('.logos_slider', true, 6, 1, false, true, false, 767, 2);
  productSlider('section#section-template--15773337190570__166375202864106698 .ArticleListWrapper .ArticleList', true, 3, 1, false, true, false, 767, 1);

  function productSlider(sliderName, dots, slidesToShow, slidesToScroll, arrows, autoplay, infinite, breakpoint, mobileSlidesToShow) {
    var slider = $(sliderName);  
    return slider.slick({
      infinite: infinite,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToScroll,
      arrows: arrows,
      dots: dots,
      autoplay: autoplay,
      autoplaySpeed: 1000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: breakpoint,
          settings: {
            slidesToShow: mobileSlidesToShow,
            slidesToScroll: 1,
            arrows: arrows
          }
        }
      ]
    });
  }
});






// $('.featured_section div#block-featured-collection-0 .ProductList').slick({
//             arrows:false,
//             dots:true,
//             slidesToShow: 4,
//             slidesToScroll: 1,
//             autoplay: true,
//             autoplaySpeed: 2000,
//             responsive: [
//                 {
//                   breakpoint: 1024,
//                   settings: {
//                     slidesToShow: 3,
//                     slidesToScroll: 1,
//                     dots: true,
//                       infinite:true,
//                   }
//                 },
//                {
//                   breakpoint: 991,
//                   settings: {
//                     slidesToShow: 3,
//                     slidesToScroll: 1,
//                     dots: false,
//                       infinite:true,
//                   }
//                 },
//                 {
//                   breakpoint: 767,
//                   settings: {
//                     slidesToShow: 1,
//                     slidesToScroll:1,
//                     dots: true,
//                       infinite:true,
                    
//                   }
//                 }
//               ]
//             } );





// testimonial js

$('.testimonials-slider').slick({
    arrows: false,
    slidesToShow: 3,
    dots: true,
    speed: 300,
    autoplay: false,
    infinite: true,
    loop: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding:'33',
    responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    centerPadding: '0px',
                    slidesToShow: 1
                  }
                }
              ]
          });
$('.anouncment_slider').slick({
    arrows: false,
    slidesToShow: 1,
    dots: true,
    speed: 300,
    autoplay: false,
    infinite: true,
    loop: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding:'33',
    responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    centerPadding: '40px',
                    slidesToShow: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    centerPadding: '0px',
                    slidesToShow: 1
                  }
                }
              ]
          });



// anouncment_slider





// dog slider js

	mobileOnlySlider(".dog_sliders", true, true, false, 1, 767);

	function mobileOnlySlider($slidername, $dots, $arrows, $slideshow, $infiniter, $breakpoint) {
		var slider = $($slidername);
		var settings = {
			mobileFirst: true,
			dots: $dots,
			arrows: $arrows,
			infinite: $infiniter,
			slidesToShow: $slideshow,
			slidesToShow:1,
			responsive: [{
				breakpoint: $breakpoint,
				settings: "unslick"
			}]
		};

		slider.slick(settings);

		$(window).on("resize", function() {
			if ($(window).width() > $breakpoint) {
				return;
			}
			if (!slider.hasClass("slick-initialized")) {
				return slider.slick(settings);
			}
		});
	}

// about-us slider

$('.about_sliders').slick({
            infinite: true,
             arrows:true,
             autoplay:true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplaySpeed: 2000,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                    arrows: true,
                     infinite: false,
                     autoplay:false,
                    
                  }
                }
              ]
            } );


  var price = document.getElementsByClassName("ProductMeta__PriceList");
   $(price).insertBefore(".ProductForm__QuantitySelector");
       



      $(document).ready(function(){
     $(".about_sliders .col-lg-4.slick-slide").click(function(){
        $(".col-lg-4.slick-slide.is-active").removeClass("is-active")
        $(this).addClass("is-active")
    });
});




var live_url = window.location.href;
var result = live_url.includes('form_type=customer');
var input_val = document.querySelector('.Newsletter__Inner input.Form__Input').value.length;
if(result && input_val != 0){
    const add_ele = document.createElement("h3");
    add_ele.innerText = "You have already subscribed!";
    document.querySelector('.Newsletter.Form').appendChild(add_ele);
    add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
}

// on click enter function

const search = document.querySelector(".Search__Input");
search.addEventListener("keyup", function(event) {
    event.preventDefault();
    if (event.keyCode === 13) {
        document.querySelector("a.Heading.Link.Link--secondary").click();
    }
});

